/**
 * Clip Api
 */
// 클립 생성
export async function setCreateClip(
  app,
  wsId,
  mtId,
  stId,
  clipId,
  clipType,
  clipDuration,
  clipNote,
  chkMtPermission,
  textClip,
  clipTitle,
  isReplaceFollowUp,
  clipUrl,
  blobType,
  contentData,
  emailNotiInfo,
  transcriptStatus,
  summaryStatus,
  sttLanguage,
  summaryTopics,
  summaryTemplate,
  audioSilenceList,
  audioFileCnt
) {
  // console.log('setCreateClip')
  return await app.$axios.post('/v1/clip/create', {
    wsId,
    mtId,
    stId,
    clipId,
    clipType,
    clipDuration,
    clipNote,
    chkMtPermission,
    textClip,
    clipTitle,
    isReplaceFollowUp,
    clipUrl,
    blobType,
    contentData,
    emailNotiInfo,
    transcriptStatus,
    summaryStatus,
    sttLanguage,
    summaryTopics,
    summaryTemplate,
    audioSilenceList,
    audioFileCnt,
  })
}

// Follow Up 클립 생성
export async function setCreateFollowUp(
  app,
  wsId,
  mtId,
  stId,
  clipType,
  clipTitle,
  expirationDate,
  displayDate,
  followUpUid,
  chkMtPermission
) {
  // console.log('setCreateFollowUp')
  return await app.$axios.post('/v1/clip/create', {
    wsId,
    mtId,
    stId,
    clipType,
    clipTitle,
    expirationDate,
    displayDate,
    followUpUid,
    chkMtPermission,
  })
}

// 투표
export async function setVoteUpdate(app, wsId, mtId, clipId, contentData) {
  // console.log('setClipUpdate')
  return await app.$axios.post('/v1/clip/update', {
    wsId,
    mtId,
    clipId,
    contentData,
  })
}

// 클립 수정
export async function setClipUpdate(
  app,
  wsId,
  mtId,
  clipId,
  clipNote,
  clipTitle,
  expirationDate,
  displayDate,
  followUpUid,
  textClip
) {
  // console.log('setClipUpdate')
  return await app.$axios.post('/v1/clip/update', {
    wsId,
    mtId,
    clipId,
    clipNote,
    clipTitle,
    expirationDate,
    displayDate,
    followUpUid,
    textClip,
  })
}

// 텍스트 클립 수정
export async function setClipTextUpdate(app, wsId, mtId, clipId, textClip) {
  // console.log('setClipUpdate')
  return await app.$axios.post('/v1/clip/update', {
    wsId,
    mtId,
    clipId,
    textClip,
  })
}

export async function watchedClip(app, wsId, mtId, clipId) {
  return await app.$axios.post('/v1/clip/watched', {
    wsId,
    mtId,
    clipId,
  })
}

export async function publicWatchedClip(app, wsId, mtId, clipId, userId) {
  return await app.$axios.post('/v1/clip/public/watched', {
    wsId,
    mtId,
    clipId,
    userId,
  })
}

// 클립 삭제
export async function deleteClip(app, type, wsId, mtId, stId, clipId) {
  // console.log('updateClipDelete')
  return await app.$axios.post('/v1/clip/delete', {
    type,
    wsId,
    mtId,
    stId,
    clipId,
  })
}

// 자막 생성
export async function createSubtitle(app, mtId, clipId, lang) {
  return await app.$axios.post('/v1/clip/create-subtitle', {
    mtId,
    clipId,
    lang,
  })
}

/**
 * 자막 삭제
 * @param {*} app
 * @param {*} wsId 워크스페이스 ID
 * @param {*} mtId 미팅 ID
 * @param {*} clipId 클립 ID
 * @param {*} subtId 자막 ID (국가코드:clipId)
 * @param {*} deleteType 삭제 타입 (vue 에서는 단일 삭제만 - 'subtitle')
 * @returns
 */
export async function deleteSubtitle(app, wsId, mtId, clipId, subtId, deleteType) {
  return await app.$axios.post('/v1/clip/delete-subtitle', {
    wsId,
    mtId,
    clipId,
    subtId,
    deleteType,
  })
}
/**
 * Clip을 시청하지 않은 사람에게 Remind 메일을 전송
 * @param {context} app
 * @param {string} wsDomain 워크스페이스 도메인명
 * @param {string} mtId mtId 미팅 ID
 * @param {string} clipId clipId 클립 ID
 * @param {array} userEmails userEmails 수신자 메일 리스트
 * @returns isSuccess - 성공 여부
 */
export async function sendRemind(app, wsDomain, mtId, clipId, userEmails) {
  return await app.$axios.post('/v1/clip/remind', {
    wsDomain,
    mtId,
    clipId,
    userEmails,
  })
}

/**
 *  Transcript 정보 호출
 * @param {*} app
 * @param {*} clipId clipId 클립 ID
 * @returns object
 */
export async function getTranscriptInfo(app, clipId) {
  return await app.$axios.post('/v1/clip/transcript/info', {
    clipId,
  })
}

/**
 * Transcript 생성
 * @param {*} app
 * @param {*} clipId 클립의 ID
 * @param {*} sttInfo STT 번역 정보 (로컬 생성시에는 mock data 전송)
 * @param {*} sttType STT 번역 타입 (로컬 생성시에는 custom 으로 전송)
 * @returns
 */
export async function createTranscriptInfo(app, clipId, sttInfo, sttType) {
  return await app.$axios.post('/v1/clip/transcript/create', {
    clipId,
    sttInfo,
    sttType,
  })
}

/**
 * Transcript 업데이트
 * @param {*} app
 * @param {*} clipId 클립의 ID
 * @param {*} tsId Transcript ID
 * @param {*} sgId Segment 의 ID
 * @param {*} sgContent Segment 의 변경할 내용 (sgcontent, sgTimestamp 둘다 null 또는 undefined 로 보내면 삭제 처리)
 * @param {*} sgTimestamp Segment 의 변경할 Timestamp (sgcontent, sgTimestamp 둘다 null 또는 undefined 로 보내면 삭제 처리)
 * @returns
 */
export async function updateTranscriptInfo(app, clipId, tsId, sgId, sgContent, sgTimestamp) {
  return await app.$axios.post('/v1/clip/transcript/update', {
    clipId,
    tsId,
    sgId,
    sgContent,
    sgTimestamp,
  })
}

/**
 * Summary 정보 호출
 * @param {*} app
 * @param {*} clipId clipId 클립 ID
 * @returns object
 */
export async function getSummaryInfo(app, clipId) {
  return await app.$axios.post('/v1/clip/summary/info', {
    clipId,
  })
}

/**
 * Summary 생성
 * @param {*} app
 * @param {*} clipId 클립의 ID
 * @param {*} summaryInfo 요약 정보 (로컬 생성시에는 mock data 전송)
 * @returns
 */
export async function createSummaryInfo(app, clipId, summaryInfo) {
  return await app.$axios.post('/v1/clip/summary/create', {
    clipId,
    summaryInfo,
  })
}

/**
 * Summary Segment 생성
 * @param {*} app
 * @param {*} clipId 클립의 ID
 * @param {*} topic summary 타이틀
 * @param {*} summary summary 내용
 * @param {*} timestamp summary 의 timestamp
 * @returns
 */
export async function createSummarySegment(app, clipId, topic, summary, timestamp) {
  return await app.$axios.post('/v1/clip/summary/create/segment', {
    clipId,
    topic,
    summary,
    timestamp,
  })
}

/**
 * Summary 업데이트
 * @param {*} app
 * @param {String} clipId 클립의 ID
 * @param {String} smId Summary ID
 * @param {String} sgId Segment 의 ID
 * @param {String} sgContent Segment 의 변경할 내용 (null 또는 undefined 로 보내면 삭제 처리)
 * @param {Number} sgTimestampIndex Segment 의 변경할 Timestamp의 Index
 * @param {Number} sgTimestamp Segment 의 변경할 Timestamp
 * @returns
 */
export async function updateSummaryInfo(app, clipId, smId, sgId, sgTopic, sgContent, sgTimestampIndex, sgTimestamp) {
  return await app.$axios.post('/v1/clip/summary/update', {
    clipId,
    smId,
    sgId,
    sgTopic,
    sgContent,
    sgTimestampIndex,
    sgTimestamp,
  })
}
